<template>
    <span class="bill-item-timer"
        >{{ startTime }}{{ endTime }} <i class="fa-light fa-timer"></i><span class="elapsed">{{ elapsed }}</span></span
    >
</template>

<script setup lang="ts">
    import { DateTime } from "@/data/util/DateTime";
    import { Misc } from "@/data/util/Misc";
    import { getTimerElapsedSeconds } from "@/data/util/TimerPrice";
    import { useNow } from "@vueuse/core";
    import { computed } from "vue";

    const props = defineProps<{
        // UTC, the Date shows it in the local time of the device
        startedDateTime: Date;
        stoppedDateTime?: Date;
        // the elapsed time of all the runs as the server told it, and when the device read it: a running timer counts on
        // from there, so the device's clock does not have to match the server's
        elapsedSeconds: number;
        elapsedReadDateTime: Date;
    }>();

    const now = useNow({ interval: 1000 });

    const startTime = computed(() => DateTime.toTimeString(props.startedDateTime, true));

    // the end time is appended once the timer is stopped
    const endTime = computed(() =>
        props.stoppedDateTime === undefined ? "" : ` - ${DateTime.toTimeString(props.stoppedDateTime, true)}`
    );

    // a running timer counts up to now, a stopped one stays at the time it was stopped
    const elapsed = computed(() => {
        const elapsedSeconds = getTimerElapsedSeconds(
            props.elapsedSeconds,
            props.elapsedReadDateTime,
            props.stoppedDateTime === undefined,
            now.value
        );
        const hours = Math.floor(elapsedSeconds / 3600);
        const minutes = Math.floor((elapsedSeconds % 3600) / 60);

        return `${Misc.padDigits(hours, 2)}:${Misc.padDigits(minutes, 2)}`;
    });
</script>

<style scoped lang="scss">
    .bill-item-timer {
        font-weight: 400;
        white-space: nowrap;

        .fa-timer {
           margin: 0 0.2em 0 0.4em
        }

        > .elapsed {
            opacity: 0.7;
        }
    }
</style>
